import { FC } from "react";
import { useLayoutContext } from "@context/layout";
import { CopounHeaderProps } from "./types";
import { CopounHeaderContent } from "./CouponHeaderContent";
import { useCopounHeader } from "./useCouponHeader";


const CopounHeader: FC<CopounHeaderProps> = (props) => {
  const { userData } = useLayoutContext();

  const { message, status, handleCourseCoupon } =
    useCopounHeader(props);



  if (!props.canPurchaseAfterCoupon) return null;

  return (
    <CopounHeaderContent
      message={message}
      isHome={props.isHome ?? false}
      isProfile={props.isProfile ?? false}
      isAdmin={userData?.user?.isAdmin ?? false}
      onMoreClick={handleCourseCoupon}
      onClose={props.closeBanner}
      status={status}
    />
  );
};

export default CopounHeader;
